import { Component, OnInit, Input, Output, OnChanges, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Moment } from 'moment';
import { FiaService } from 'src/app/services/fia.service';
import { MediaService } from 'src/app/services/media.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { LookupFiaStatus } from 'src/app/shared/models/general/lookup-fia-status';
import { LookupMediaTypes } from 'src/app/shared/models/general/lookup-media-types';
import { MediaInfo } from 'src/app/shared/models/general/media-info';
import { Fia } from 'src/app/shared/models/users/fia';
import { FiaApplication } from 'src/app/shared/models/users/fia-application';
import { UserFiaPinDocument } from 'src/app/shared/models/users/user-fia-pin-document';
import { UserFiaPins } from 'src/app/shared/models/users/user-fia-pins';
import { UserFullDetails } from 'src/app/shared/models/users/user-full-details';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import { Users } from 'src/app/shared/models/users/users';
import { Error } from 'src/app/shared/models/general/error';

@Component({
  selector: 'app-user-fia-pin',
  templateUrl: './user-fia-pin.component.html',
  styleUrls: ['./user-fia-pin.component.scss'],
})
export class UserFiaPinComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('userFiaPinModal', { static: true }) userFiaPinModal: any;
  @ViewChild('file') file;

  @Input() selectedUserProfile: UserProfile;
  @Input() showModal: boolean = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() onModelChange = new EventEmitter<UserProfile>();

  busy: boolean = false;
  showError: boolean;
  errorMsg: string = '';
  fiaStatus: LookupFiaStatus[] = [];
  mediaTypes: LookupMediaTypes[] = [];

  userProfile: UserProfile = new UserProfile();

  manuallyEnterPinInfo: boolean = false;

  //FIA Pin
  newPin: UserFiaPins = new UserFiaPins();
  currentYear = moment().year();
  startDate = moment().add(1, 'days');
  pinDocument: MediaInfo;

  manualRequestReferenceNumber: string = '';

  constructor(
    public settingsService: SettingsService,
    public usersService: UserService,
    public activeModal: NgbActiveModal,
    public fiaService: FiaService,
    public mediaService: MediaService
  ) {}

  ngOnInit(): void {
    this.fiaStatus = this.settingsService.fiaStatus;
    this.mediaTypes = this.settingsService.mediaTypes;
  }

  ngOnChanges() {
    this.showHideModal(null);
  }

  ngAfterViewInit() {}

  onClosed(event: any) {
    if (this.showModal != false) {
      this.showModal = false;
      this.showModalChange.emit(this.showModal);
    }
  }

  //Moment date Functions for fia appliations
  myDateFilter = (m: Moment | null): boolean => {
    const today = m || moment();
    return today >= moment().utcOffset('+02:00').subtract(0, 'days');
  };

  showHideModal(toggle: boolean) {
    if (toggle != null) {
      this.showModal = toggle;
    }

    this.manualRequestReferenceNumber = '';
    this.manuallyEnterPinInfo = false;

    if (this.showModal) {
      this.userFiaPinModal.show();

      this.userProfile = <UserProfile>JSON.parse(JSON.stringify(this.selectedUserProfile));
      this.newPin.userId = this.userProfile.userId;
    } else if (!this.showModal) {
      // Blur any focused element before hiding modal to prevent aria-hidden warning
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.newPin = new UserFiaPins();
      this.pinDocument = null;
      this.showError = false;
      this.errorMsg = '';
      this.userFiaPinModal.hide();
    }

    this.showModalChange.emit(this.showModal);
  }

  fiaPinCreateClicked() {
    this.busy = true;

    if (!this.pinDocument) {
      this.showError = true;
      this.errorMsg = 'No pin document attached';
      this.busy = false;
      return;
    }

    if (this.manualRequestReferenceNumber?.length == 25) {
      this.newPin.manuallyEnteredReferenceNumber = this.manualRequestReferenceNumber;
      this.newPin.pinExpiryDate = moment(this.newPin.pinIssueDate).add(1, 'years').add(-2, 'days').toDate();

      this.newPin.pinMedia = this.pinDocument;
    }

    this.fiaService.CreateFiaPin(this.newPin).subscribe(
      (_: UserFiaPins) => {
        this.manualRequestReferenceNumber = '';
        this.manuallyEnterPinInfo = false;
        this.showError = false;
        this.busy = false;
        this.onModelChange.emit(this.selectedUserProfile);
        this.showHideModal(false);
      },
      (error) => {
        this.showError = true;
        this.errorMsg = Error.InterpretErrorMessage(error);
        //this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  public ValidateFiaPinMedia(media: MediaInfo) {
    this.manualRequestReferenceNumber = '';
    this.manuallyEnterPinInfo = false;

    this.newPin = new UserFiaPins();
    this.newPin.userId = this.userProfile.userId;

    this.fiaService.ValidateFiaPinDocument(media).subscribe(
      (response: UserFiaPinDocument) => {
        if (response.fileClassification == 'Sars Communication - FIA TCS Pin Issued') {
          this.showError = false;
          media.fileType = response.fileClassification;
          this.pinDocument = media;
          this.newPin.pin = response.pin;
          this.newPin.pinIssueDate = response.pinIssueDate;
          this.newPin.pinExpiryDate = response.pinExpiryDate;
          this.newPin.pinMedia = this.pinDocument;
        } else {
          this.showError = true;
          this.errorMsg = 'Document is not a valid TCS Pin document';
          this.manuallyEnterPinInfo = true;
        }
        this.busy = false;
      },
      (error) => {
        this.manuallyEnterPinInfo = true;
        this.showError = true;
        this.errorMsg = Error.InterpretErrorMessage(error);
        this.busy = false;
      }
    );
  }

  addFiles() {
    this.file.nativeElement.click();
  }

  onFileChange(fileInput: any) {
    this.pinDocument = new MediaInfo();
    var totalSize: number = 0;
    var maxSize: number = 5000000;
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          if (totalSize <= maxSize && files[key].size <= maxSize) {
            this.showError = false;
            var file: MediaInfo = new MediaInfo();
            file.name = files[key].name;
            file.fileName = files[key].name;
            file.mimeType = files[key].type;
            file.tag = 'Sars Communication';
            file.fileType = 'Sars Communication - Other';
            file.data = event.target.result;
            file.data = file.data.replace('data:' + files[key].type + ';base64,', '');
            file.entityId = this.userProfile.userId;
            file.entityType = this.settingsService.userEntity.description; // Users
            totalSize += files[key].size;
            this.pinDocument = file;
            this.ValidateFiaPinMedia(this.pinDocument);
          } else {
            console.log('Max upload size reached');
            this.showError = true;
            this.errorMsg = 'Max file upload size reached';
          }
        };

        reader.readAsDataURL(files[key]);
      }
    }
  }

  removeFile(fileName: string) {
    this.busy = true;
    this.pinDocument = null;
    this.file.nativeElement.value = '';
    this.busy = false;
  }

  canCreatePin() {
    if (this.manuallyEnterPinInfo === false) {
      return true;
    }

    const isManualFormValid =
      this.newPin.pin?.length === 10 && !!this.newPin.pinIssueDate && this.manualRequestReferenceNumber.length === 25;

    return isManualFormValid;
  }
}
